import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import { application } from '../application'

import Benefit from '../front_stage/benefit_controller'
import CheckProducts from '../front_stage/check_products_controller'
import CompareSeeMore from '../front_stage/compare_see_more_controller'
import DetailsWithModal from '../front_stage/details_with_modal_controller'
import FooterScroll from '../front_stage/footer_scroll_controller'
import HideEmptyContentElement from '../front_stage/hide_empty_content_element_controller'
import PlanTabs from '../front_stage/plan_tabs_controller'
import SetConversionCookies from '../front_stage/set_conversion_cookies_controller'
import StructuredDataFaq from '../front_stage/structured_data_faq_controller'
import TabPanel from '../front_stage/tab_panel_controller'

application.register('benefit', Benefit)
application.register('check-products', CheckProducts)
application.register('compare-see-more', CompareSeeMore)
application.register('details-with-modal', DetailsWithModal)
application.register('footer-scroll', FooterScroll)
application.register('hide-empty-content-element', HideEmptyContentElement)
application.register('plan-tabs', PlanTabs)
application.register('set-conversion-cookies', SetConversionCookies)
application.register('structured-data-faq', StructuredDataFaq)
application.register('tab-panel', TabPanel)

const context = require.context('.', true, /_controller\.js$/)
application.load(definitionsFromContext(context))
